var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateLandingPage',{attrs:{"imageExt":"png","imageName":"Access","routePath":"accessdevelopment","company":"Access"}})
}
var staticRenderFns = []

export { render, staticRenderFns }